import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './theme.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ConfigProvider} from 'antd';
import frFR from 'antd/lib/locale/fr_FR';
import enUS from 'antd/lib/locale/en_US';
import moment from 'moment';
import 'moment/locale/fr';
import {THEME} from './constant/theme';
import {SITE_THEME, LANG} from './constant/Config';

moment.locale(LANG === 'en' ? 'en' : 'fr');
const antdLocale = LANG === 'en' ? enUS : frFR;

if (SITE_THEME === 'globalong') {
    const svgIcon = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
    if (svgIcon) svgIcon.href = process.env.PUBLIC_URL + '/favicon-globalong.svg';
}

document.title = THEME.brand;

const root = document.documentElement;
root.style.setProperty('--theme-text', THEME.colors.text);
root.style.setProperty('--theme-primary', THEME.colors.primary);
root.style.setProperty('--theme-btn-bg', THEME.colors.btnBg);
root.style.setProperty('--theme-btn-bg-hover', THEME.colors.btnBgHover);
root.style.setProperty('--theme-btn-text', THEME.colors.btnText);
root.style.setProperty('--theme-link', THEME.colors.link);


ReactDOM.render(
    <React.StrictMode>
        <ConfigProvider locale={antdLocale}>
            <App/>
        </ConfigProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
